import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import { Link } from "react-router-dom";
import { FaBrain, FaRobot, FaChartLine, FaLanguage, FaEye, FaDatabase, FaCogs, FaLightbulb } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const services = [
    { icon: FaBrain, title: "Machine Learning Models", description: "Custom ML models for accurate predictions and data-driven decisions." },
    { icon: FaRobot, title: "Intelligent Automation", description: "Automate repetitive tasks and workflows to reduce manual effort." },
    { icon: FaChartLine, title: "Predictive Analytics", description: "Forecast trends and outcomes with advanced data analytics." },
    { icon: FaLanguage, title: "Natural Language Processing", description: "Chatbots and text analysis for better customer interactions." },
    { icon: FaEye, title: "Computer Vision", description: "Image recognition and visual analysis for security and integration." },
    { icon: FaDatabase, title: "Data Engineering", description: "Robust pipelines for clean, relevant data processing." },
    { icon: FaCogs, title: "Model Deployment", description: "Reliable ML deployment with monitoring and continuous improvement." },
    { icon: FaLightbulb, title: "AI Strategy", description: "Expert guidance on AI adoption and implementation strategies." },
];

const AIMachineLearning = () => {
    const canvasRef = useRef(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = 600;

        const particles = [];
        const particleCount = 40;

        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.vx = (Math.random() - 0.5) * 0.5;
                this.vy = (Math.random() - 0.5) * 0.5;
                this.radius = Math.random() * 2 + 1;
            }

            update() {
                this.x += this.vx;
                this.y += this.vy;

                if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
                if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
            }

            draw() {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(255, 193, 7, 0.6)';
                ctx.fill();
            }
        }

        for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
        }

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            particles.forEach((particle, i) => {
                particle.update();
                particle.draw();

                particles.slice(i + 1).forEach(otherParticle => {
                    const dx = particle.x - otherParticle.x;
                    const dy = particle.y - otherParticle.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < 100) {
                        ctx.beginPath();
                        ctx.strokeStyle = `rgba(255, 193, 7, ${0.3 * (1 - distance / 100)})`;
                        ctx.lineWidth = 1;
                        ctx.moveTo(particle.x, particle.y);
                        ctx.lineTo(otherParticle.x, otherParticle.y);
                        ctx.stroke();
                    }
                });
            });

            requestAnimationFrame(animate);
        }

        animate();

        const handleResize = () => {
            canvas.width = window.innerWidth;
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>AI & Machine Learning - Syrol Tech</title>
                <meta name="description" content="Intelligent solutions that leverage data, automation, and predictive analytics to enhance decision-making, personalization, and operational efficiency." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="AI & Machine Learning"
                pageName="AI & Machine Learning"
                breadcrumbsImg={bannerbg}
            />

            {/* Neural Network Animated Hero with Banner */}
            <section style={{
                backgroundImage: `url(${bannerbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '120px 0 80px',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(32, 32, 32, 0.90)',
                    zIndex: 1
                }}></div>

                <canvas ref={canvasRef} style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 2
                }} />

                <div className="container" style={{ position: 'relative', zIndex: 3 }}>
                    <div className="row align-items-center">
                        <div className="col-lg-12 text-center">
                            <div style={{ animation: 'fadeInScale 0.8s ease-out' }}>
                                <div style={{
                                    display: 'inline-block',
                                    padding: '10px 25px',
                                    background: '#ffc107',
                                    borderRadius: '30px',
                                    marginBottom: '25px'
                                }}>
                                    <span style={{ color: '#202020', fontWeight: 700, fontSize: '0.95rem' }}>
                                        🤖 ARTIFICIAL INTELLIGENCE & MACHINE LEARNING
                                    </span>
                                </div>

                                <h1 style={{
                                    color: '#fff',
                                    fontWeight: 800,
                                    fontSize: '3.8rem',
                                    marginBottom: '25px',
                                    lineHeight: 1.2,
                                    textShadow: '0 2px 20px rgba(0,0,0,0.5)'
                                }}>
                                    Intelligent AI Solutions
                                </h1>

                                <p style={{
                                    color: 'rgba(255,255,255,0.95)',
                                    fontSize: '1.3rem',
                                    maxWidth: '800px',
                                    margin: '0 auto 40px',
                                    lineHeight: 1.7
                                }}>
                                    Leverage data and automation to enhance decision-making and efficiency.
                                </p>

                                <Link to="/share-idea" style={{
                                    display: 'inline-block',
                                    padding: '18px 50px',
                                    background: '#ffc107',
                                    color: '#202020',
                                    borderRadius: '50px',
                                    fontWeight: 700,
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    boxShadow: '0 15px 40px rgba(255, 193, 7, 0.4)',
                                    transition: 'all 0.3s ease'
                                }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                        e.target.style.boxShadow = '0 20px 50px rgba(255, 193, 7, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 15px 40px rgba(255, 193, 7, 0.4)';
                                    }}>
                                    Explore AI Solutions
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Grid Services with Brand Colors */}
            <section style={{ padding: '100px 0', background: '#f8fafc' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 style={{
                            fontSize: '2.8rem',
                            fontWeight: 800,
                            color: '#202020',
                            marginBottom: '15px'
                        }}>
                            Our AI & Machine Learning Services
                        </h2>
                        <div style={{ width: '80px', height: '4px', background: '#ffc107', margin: '0 auto 15px' }}></div>
                        <p style={{ color: '#505050', fontSize: '1.1rem' }}>
                            Cutting-edge AI solutions tailored to your business needs
                        </p>
                    </div>

                    <div className="row g-4">
                        {services.map((service, index) => {
                            const Icon = service.icon;

                            return (
                                <div key={index} className="col-lg-3 col-md-6">
                                    <div
                                        style={{
                                            background: '#fff',
                                            borderRadius: '20px',
                                            padding: '35px',
                                            height: '100%',
                                            minHeight: '320px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                            animation: `bounceIn 0.6s ease-out ${index * 0.1}s both`,
                                            cursor: 'pointer',
                                            border: '2px solid #e9ecef',
                                            boxShadow: hoveredIndex === index ? '0 20px 40px rgba(255, 193, 7, 0.3)' : '0 5px 15px rgba(0,0,0,0.08)'
                                        }}
                                        onMouseEnter={() => setHoveredIndex(index)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                    >
                                        <div style={{
                                            position: 'absolute',
                                            top: '-50px',
                                            right: '-50px',
                                            width: '150px',
                                            height: '150px',
                                            background: hoveredIndex === index ? 'rgba(255, 193, 7, 0.1)' : 'rgba(0,0,0,0.02)',
                                            borderRadius: '50%',
                                            transition: 'all 0.5s ease',
                                            transform: hoveredIndex === index ? 'scale(1.5)' : 'scale(1)'
                                        }}></div>

                                        <div style={{ position: 'relative', zIndex: 1 }}>
                                            <div style={{
                                                width: '70px',
                                                height: '70px',
                                                background: hoveredIndex === index ? '#ffc107' : '#f8f9fa',
                                                borderRadius: '15px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '20px',
                                                transition: 'all 0.3s ease',
                                                boxShadow: hoveredIndex === index ? '0 10px 25px rgba(255, 193, 7, 0.4)' : 'none'
                                            }}>
                                                <Icon style={{
                                                    fontSize: '35px',
                                                    color: hoveredIndex === index ? '#202020' : '#505050',
                                                    transition: 'all 0.3s ease'
                                                }} />
                                            </div>

                                            <h3 style={{
                                                color: '#202020',
                                                fontWeight: 700,
                                                fontSize: '1.2rem',
                                                marginBottom: '12px'
                                            }}>
                                                {service.title}
                                            </h3>

                                            <p style={{
                                                color: '#505050',
                                                fontSize: '0.95rem',
                                                lineHeight: 1.6,
                                                margin: 0
                                            }}>
                                                {service.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />

            <style>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: scale(0.3);
          }
          50% {
            transform: scale(1.05);
          }
          70% {
            transform: scale(0.9);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        @media (max-width: 991px) {
          h1 {
            font-size: 2.8rem !important;
          }
        }

        @media (max-width: 767px) {
          h1 {
            font-size: 2.2rem !important;
          }
        }
      `}</style>
        </React.Fragment>
    );
};

export default AIMachineLearning;
